export const PUCK_CONFIG = {
    FontFamily: "var(--puck-font-family) !important",
} as const;
